<mat-sidenav-container class="sidenav-container">

  <mat-sidenav #drawer
               class="sidenav"
               [class.hidden]="(isHandset$ | async)"
               fixedInViewport="false"
               [attr.role]="'dialog'"
               [mode]="'over'"
               [opened]="false">
    <mat-toolbar>
      <mat-toolbar-row>
        <ng-container *ngTemplateOutlet="profileMenu"></ng-container>
        <span class="spacer"></span>
        <ng-container *ngTemplateOutlet="logoutButton"></ng-container>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-divider></mat-divider>

    <mat-nav-list>
      <ng-container *ngTemplateOutlet="menus"></ng-container>
      <mat-divider style="margin-block: 8px"></mat-divider>
      <ng-container *ngTemplateOutlet="moduleMenuContent"></ng-container>
    </mat-nav-list>

    <div class="toolbar-bottom">
      <mat-divider></mat-divider>
      <mat-toolbar-row>
        <ng-container *ngTemplateOutlet="darkModeSwitch"></ng-container>
        <ng-container *ngTemplateOutlet="languageSelect"></ng-container>
      </mat-toolbar-row>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="progress-toolbar-container">
      <mat-toolbar color="primary">
        <button type="button"
                aria-label="Toggle sidenav"
                mat-icon-button
                (click)="drawer.toggle()"
                *ngIf="(isHandset$ | async)">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>

        <a [routerLink]="['/']" class="base-favicon"> </a>

        <ng-container *ngIf="!(isHandset$ | async)">
          <ng-container *ngTemplateOutlet="menus"></ng-container>
        </ng-container>

        <ng-container *ngTemplateOutlet="spacer"></ng-container>

        <ng-container *ngIf="!(isHandset$ | async)">

          <div class="right-side">
            <div fxShow.sm="true"
                 fxShow.gt-sm="true"
                 fxShow.gt-md="true"
                 fxShow="false"
                 *ngIf="isAuthenticated">

              <ng-container *ngTemplateOutlet="companyRouteName"></ng-container>
              <ng-container *ngTemplateOutlet="moduleMenusIcon"></ng-container>
              <ng-container *ngTemplateOutlet="profileMenu"></ng-container>
              <ng-container *ngTemplateOutlet="darkModeSwitch"></ng-container>
              <ng-container *ngTemplateOutlet="languageSelect"></ng-container>
              <ng-container *ngTemplateOutlet="logoutButton"></ng-container>
            </div>
          </div>

        </ng-container>

      </mat-toolbar>
      <div class="progress-bar-container">
        <mat-progress-bar *ngIf="loading"
                          color="accent"
                          mode="indeterminate"></mat-progress-bar>
      </div>
    </div>

    <ng-container *ngIf="isUpdateWarningVisible()">
      <div class="app-update-warning" (click)="reloadPage()">
        <div *ngFor="let number of [0,1]" class="app-update-warning-text">
          {{ "app-update-warning-please-refresh-message" | translate }}
        </div>
      </div>
    </ng-container>

    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #spacer>
  <!--<span class="spacer"></span>-->
  <h1>
    {{ currentMenu?.mendtbshort }}
  </h1>
</ng-template>

<ng-template #menus>
  <div class="nav-bar-menu" *ngIf="companyRouteService.companyId != null">
    <a *ngFor="let m of menu"
       aria-label="NKN.Storage"
       mat-button
       tabindex="0"
       aria-disabled="false"
       [routerLink]="['/' + companyRouteService.companyId + '/' + m.mencontroller]"
       routerLinkActive="active"
       href="#">
      <span class="mat-button-wrapper">
        <span class="menu-span">{{ m.mendtbshort | translate}}</span>
      </span>
      <div class="mat-button-ripple mat-ripple" matripple></div>
      <div class="mat-button-focus-overlay"></div>
    </a>
  </div>
</ng-template>

<ng-template #companyRouteName>
  <!--<p class="company">{{ currentCompany }}</p>-->
  <ng-container *ngIf="companyRouteService.companyId">
    <mat-form-field id="companySelectList">
      <!--<mat-label>{{ 'company' | translate }}</mat-label>-->
      <mat-select (selectionChange)="onSelectionChanged($event)"
                  [value]="companyRouteService.companyId">
        <ng-container *ngFor="let item of companyRouteService.getAllCompanyIds() | async">
          <mat-option [value]="item.id">{{ item.text }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </ng-container>
</ng-template>

<ng-template #moduleMenusIcon>
  <ng-container *ngIf="moduleMenu && moduleMenu?.length > 0">
    <button mat-icon-button
            [matMenuTriggerFor]="modules"
            aria-label="Modules menu"
            style="font-size: large">
      <mat-icon>apps</mat-icon>
    </button>
    <mat-menu #modules="matMenu">
      <div matMenuContent>
        <ng-container *ngTemplateOutlet="moduleMenuContent"></ng-container>
      </div>
    </mat-menu>
  </ng-container>
</ng-template>

<ng-template #moduleMenuContent>
  <div class="nav-bar-menu" *ngFor="let m of moduleMenu">
    <!--'mat-mdc-menu-item mdc-list-item' = mat-menu-item-->
    <!--'mdc-button mat-mdc-button mat-unthemed mat-mdc-button-base' = mat-button-->
    <a [ngClass]="{
          'mat-mdc-menu-item mdc-list-item': !(isHandset$ | async),
          'mdc-button mat-mdc-button mat-unthemed mat-mdc-button-base': (isHandset$ | async),
       }"
       aria-label="NKN.Storage"
       tabindex="0"
       aria-disabled="false"
       [href]="m.mencontroller"
       routerLinkActive="active">
      <mat-icon *ngIf="m.menicon">
        {{ m.menicon }}
      </mat-icon>
      <span class="mat-button-wrapper">
        <span class="menu-span">{{ m.mendtbshort | translate }}</span>
      </span>
      <div class="mat-button-ripple mat-ripple" matripple=""></div>
      <div class="mat-button-focus-overlay"></div>
    </a>
  </div>
</ng-template>

<ng-template #profileMenu>
  <button mat-button
          [matMenuTriggerFor]="menu"
          aria-label="User menu"
          style="font-size: large">
    {{ userLongName }}
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item [routerLink]="companyRouteService.companyId ? '/' + companyRouteService.companyId + '/profile' : '/profile'">
      <mat-icon>account_circle</mat-icon>
      <span>{{ 'profile' | translate }}</span>
    </button>
  </mat-menu>
</ng-template>

<ng-template #darkModeSwitch>
  <mat-slide-toggle matTooltip="{{ 'light-dark-mode-switch' | translate }}"
                    matTooltipClass="big-tooltip"
                    class="icon-slide-toggle"
                    (change)="onThemeChanged()"
                    [checked]="themeService.isDarkMode">
  </mat-slide-toggle>
</ng-template>

<ng-template #languageSelect>
  <button mat-icon-button [matMenuTriggerFor]="languageSelect">
    <i class="material-icons"> translate </i>
  </button>
  <mat-menu #languageSelect="matMenu">
    <div *ngFor="let lang of languageList">
      <button mat-menu-item
              [value]="lang.id"
              (click)="changeUserLang(lang.id)">
        <span>{{ lang.text }}</span>
      </button>
    </div>
  </mat-menu>
</ng-template>

<ng-template #logoutButton>
  <button (click)="logout()"
          mat-icon-button
          *ngIf="isAuthenticated">
    <mat-icon aria-label="logout">exit_to_app</mat-icon>
  </button>
</ng-template>
